import React, {useState, useCallback, useMemo, useEffect, memo} from "react";
import FooterMiddlePart from "./widgets/FooterMiddlePart";
import FooterBottomPart from "./widgets/FooterBottomPart";
import {
    FooterSearchDiv,
    FooterSearchIcon,
    FooterSection,
    ScrollToTopIcon,
    ScrollToTopLink,
    ScrollToTopSection,
} from "./widgets/FooterStyled";
import PropTypes from "prop-types";
import ComponentVisibilityHOC from "../../hoc/ComponentVisibilityHOC";
import ProgressiveHydration from "../ProgressiveHydration";
import {validateField} from "../../utils/validation";
import {useDispatch, useSelector} from "react-redux";
import {fetchFooter} from "../Layout/actions";
import {useAnchorForExternalLinks} from "../../hooks/useAnchorForExternalLinks";
import FooterCopyright from "./widgets/FooterCopyright";
import FooterBottomInfoWidget from "./widgets/FooterBottomInfoWidget";
import config from "../../config/config";

const Footer = (props) => {
    const {isComponentShown, userLoggedIn, isMobile, hideFooterSearch} = props;
    const [activeTabId, setActiveTabId] = useState("");
    const dispatch = useDispatch();
    const footerData = useSelector((state) => state.layout?.footerItems);
    // const pageStr = useSelector((state) => state.layout?.currentPageName ?? "");
    const dashboardBottomHeight = useSelector((state) => state.layout?.dashboardBottomHeight ?? 0);
    const showFooter = useSelector((state) => state.layout?.showFooter ?? 0);
    useAnchorForExternalLinks(userLoggedIn);

    const footerHandler = useCallback(
        (id) => {
            if (activeTabId === id) {
                setActiveTabId("");
            } else {
                setActiveTabId(id);
            }
        },
        [activeTabId],
    );

    const isActive = useCallback(
        (id) => {
            return id === activeTabId;
        },
        [activeTabId],
    );

    useEffect(() => {
        if (!validateField(footerData, "object")) {
            dispatch(fetchFooter());
        }
    }, [footerData, dispatch]);

    return useMemo(() => {
        if (!showFooter) {
            return null;
        }
        if (!validateField(footerData, "object")) {
            return <div>Loading...</div>;
        }
        // let partnerItem = isActive("footer-partner-us") ? "active" : "";
        // let partnerItemIcn = isActive("footer-partner-us") ? "minus-icon" : "";
        return (
            <FooterSection
                isComponentShown={isComponentShown}
                dashboardBottomHeight={dashboardBottomHeight}
            >
                <ProgressiveHydration>
                    {/* <FooterUpperSection>
                    <p>
                        Take our free 30 minute consultation session Book a free
                        session with our counsellors and get your doubts
                        cleared!
                    </p>
                </FooterUpperSection> */}
                    {isMobile && (
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                window.scrollTo(0, 0);
                            }}
                        >
                            <ScrollToTopSection>Top of Page</ScrollToTopSection>
                        </a>
                    )}
                    <div>
                        {!hideFooterSearch && isMobile && (
                            <a href={`${config.SHIKSHA_STUDYABROAD_HOME}/searchLayer`}>
                                <FooterSearchDiv>
                                    <p>
                                        <span>Search College, Course or Exam</span>
                                        <FooterSearchIcon />
                                    </p>
                                </FooterSearchDiv>
                            </a>
                        )}
                    </div>
                    <FooterMiddlePart
                        footerData={footerData.data}
                        footerHandler={footerHandler}
                        isActive={isActive}
                        isMobile={isMobile}
                    />
                    <FooterBottomPart
                        footerData={footerData.data}
                        footerHandler={footerHandler}
                        isActive={isActive}
                        isMobile={isMobile}
                    />
                    <FooterBottomInfoWidget isMobile={isMobile} />

                    <FooterCopyright isMobile={isMobile} />
                    {!isMobile && (
                        <ScrollToTopLink>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.scroll(0, 0);
                                }}
                            >
                                <ScrollToTopIcon />
                            </a>
                        </ScrollToTopLink>
                    )}
                </ProgressiveHydration>
            </FooterSection>
        );
    }, [
        dashboardBottomHeight,
        footerData,
        footerHandler,
        hideFooterSearch,
        isActive,
        isComponentShown,
        showFooter,
        isMobile,
    ]);
};
Footer.propTypes = {
    isComponentShown: PropTypes.bool,
    hideFooterSearch: PropTypes.bool,
};

export default ComponentVisibilityHOC(memo(Footer));
